import { memo } from 'react';

import type { Client } from '@/types';
import { ClientListItem } from '@/features/clients';
import styles from './ClientsList.module.css';

interface ClientsListProps {
  clients: Client[];
  onClick: (client: Client) => void;
  onLongPress: (client: Client) => boolean;
  isSelectionMode: boolean;
  isExitingSelection: boolean;
  selectedClients: Set<string>;
  onToggleSelect: (id: string) => void;
  canMarkVisit: (client: Client) => boolean;
  pendingVisitClientIds?: Set<string>;
}

export const ClientsList = memo(function ClientsList({
  clients,
  onClick,
  onLongPress,
  isSelectionMode,
  isExitingSelection,
  selectedClients,
  onToggleSelect,
  canMarkVisit,
  pendingVisitClientIds,
}: ClientsListProps) {
  return (
    <div className={styles.list}>
      {clients.map((client) => (
        <ClientListItem
          key={client.id}
          client={client}
          isVisitPending={pendingVisitClientIds?.has(client.id)}
          onClick={onClick}
          onLongPress={onLongPress}
          isSelectionMode={isSelectionMode}
          isExitingSelection={isExitingSelection}
          isSelected={selectedClients.has(client.id)}
          onToggleSelect={onToggleSelect}
          canMarkVisit={canMarkVisit(client)}
        />
      ))}
    </div>
  );
});
